import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"
import agent from '../agent'

import Moment from 'react-moment'
import 'moment-timezone';

import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png'
import Back from "../components/Back"




const Header = ({clientDetails, artistInfo}) => {
	return (
		<section id="brand-logo" className="section-brand-logo project-confirmation section">
		  <div className="row text-center">
			  <div className="small-12 small-centered column">
			  	<div className="header-image-container">
				  	<img className="company-logo" src={ clientDetails.client.logo_url } alt="" />
			  	</div>
			  </div>
		  </div>

		  <div className="row">
	  		<div className="small-12 small-centered column text-center with-name post-relative">
	  				<Back />
	  				<div className="post-relative artist-info">
		  				<img className="small-artist-photo" src={artistInfo.photo_thumb} alt=""/>
		  				<h2>{artistInfo.first_name}</h2>
				  		<p className="top-title"> Confirm your audition details below</p>
				  	</div>
	  		</div>
	    </div>

		</section>
	)
}

const RenderRole = ({role}) => {
	return (
		<div className="row">
			<div className="small-2 medium-1 column text-center">
				<i className="fa fa-user-o"></i>
			</div>
			<div className="small-2 medium-2 column text-center">{role.name}</div>
			<div className="small-8 medium-9 column">
				<p className="role">{`${role.category} ${role.gender} / ${role.age_from}-${role.age_to} years`}</p>
				<p className="role-description">{role.description}</p>
			</div>
		</div>
	)
}

const RenderAudition = ({auditionEvent}) => {
	const hourTime = new Date()

	// const start_time = moment(auditionEvent.start_time);
	return (
		<div className="row">
			<div className="small-1 column">
				<i className="fa fa-calendar"></i>
			</div>
			<div className="small-3 column">Audition</div>
			<div className="small-8 column">
				<p><Moment format="LLLL" tz={auditionEvent.time_zone}>{auditionEvent.start_time}</Moment></p>
				<p className="blue-text">22mins from now current time is <Moment  interval={0}>{hourTime}</Moment></p>
				<p className="green-text">
					<span className="fa fa-star-o"></span> 
					Nice work you are on time and early! this will be timed stamped in your checkin details 
					alongside your audition today</p>
			</div>
		</div>
	)
}

const RenderLocation = ({locations, room}) => {
	return (
		<div className="row">
			<div className="small-1 column">
				<i className="fa fa-map-pin"></i>
			</div>
			<div className="small-3 column">Location</div>
			<div className="small-8 column">
				<p>{room.name}</p>

				{
					locations.map(location => {
						if (location.id === room.location_id) {
							return <p key={location.id}>{location.address}</p>
						}
					})
				}
				
			</div>
		</div>
	)
}

class ArtistProjectConfirmation extends Component {
	state = {
		projectId: new URLSearchParams(this.props.location.search).get('project'),
	}
	componentWillMount() {
		const { projectId } = this.state
		const { client, location } = this.props

		// if ( !location.state.projectDetails ) {
		// 	this.props.onLoad(agent.Client.checkProjectArtist(projectId, location.state.artist.id))
		// }
		// console.log('slkfdj')

	}
	render() {
		const { client, location } = this.props
		const { meta, roles, project, rooms, locations, companies, audition_events } = this.props.location.state.projectDetails
		
		if (!client) {
			return (
				<div id="project-confirmation">
				<Header {...location.state} artistInfo={location.state.artist}/>
				<section className="gray-bg section">
					<p className="text-center loading-text">Loading...</p>
				</section>
				</div>
			)
		}

		return (
			<div id="project-confirmation">
			<Header {...location.state} artistInfo={location.state.artist}/>

	      <section id="project-description" className="lightgray-bg section">
				  <div className="row">
				  <div className="small-12 medium-8 medium-centered columns text-center">
				   	<img className="project-logo" src={location.state.clientDetails.projectId.cover_url} alt=""/>
				    <p>{location.state.clientDetails.projectId.description || 'Description text placeholder'}</p>
				  </div>
				  </div>
				</section>

	      <section id="project-confirmation-section" className="white-text section-project-confirmation gray-bg section">
	      	<div className="row">
	      	<div className="small-12 medium-8 medium-centered columns">
						
						{ roles.length >= 1 &&
							<div className="text-center">
								<h2>{location.state.artist.first_name}, We found your audition details</h2>
							</div>	
						}

						{
							!roles.length &&
							<div className="text-center">
								<h2>{location.state.artist.first_name}, Sorry this project doesn't have available roles yet</h2>
							</div>	
						}
						
						<div className="checkin-audtion-details">

							{
								meta.has_audition
									? meta.audition.map(audition => 
											
												<div key={audition.id}>
													{	roles.map(role => 
															role.id === audition.role_id &&
															<RenderRole role={role} key={role.id} />
														)
													}

													{
															audition.audition_event_id &&
											          audition_events.map(audition_event => {
											           	return (
											           		<div>

											           		{
													          	audition_event.id === audition.audition_event_id && 
													          	<div>
													          		<RenderAudition auditionEvent={audition_event} key={audition_event.id}/>
													          			{audition_event.room_id &&
															           		rooms.map(room => 
															             		room.id === audition_event.room_id &&
																              	<RenderLocation key={room.id} locations={locations} room={room} />
														           		)}
														           </div>
													         	}

													        	</div>
												        	)
										          	})
													}

							          </div>
											
										)
									: roles.map(role => {
											return <RenderRole role={role} key={role.id} />
										})

							}
							
						</div>

					</div>
					</div>

	      </section>

	    	<section className="text-center section">
	    	{ !roles.length
	    		? <button className="button primary" disabled={!roles.length}>Next</button>
	    		: <Link 
						className="button primary"
						to={{pathname: `/projects/checkin/${this.state.projectId}`, 
							state: {
								artist: location.state.artist,
								clientDetails: location.state.clientDetails,
								projectDetails: location.state.projectDetails,
								hasAudition: meta.has_audition
							}}}>Next</Link>
	    	}
		  	</section>
	    </div>
		)
	}
}

const mapStateToProps = state => ({
	...state.auth,
	...state.common,
	...state.artist,
	client: state.client
	
})
const mapDispatchToProps = (dispatch) => ({
	onLoad: payload =>
		dispatch({type: 'LOAD_PROJECT_CONFIRMATION', payload: payload}),
})
export default connect(mapStateToProps, mapDispatchToProps)(ArtistProjectConfirmation)





// WEBPACK FOOTER //
// ./src/containers/ArtistProjectConfirmation.js